//MUI icons
import BookIcon from '@mui/icons-material/Book';
import StoreIcon from '@mui/icons-material/Store';
import BuildIcon from '@mui/icons-material/Build';
import FolderIcon from '@mui/icons-material/Folder';
import ArticleIcon from '@mui/icons-material/Article';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CommentIcon from '@mui/icons-material/Comment';
import SettingsIcon from '@mui/icons-material/Settings';
import CategoryIcon from '@mui/icons-material/Category';
import DiscountIcon from '@mui/icons-material/Discount';
import ViewComfyIcon from '@mui/icons-material/ViewComfy';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InventoryIcon from '@mui/icons-material/Inventory';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PeopleIcon from '@mui/icons-material/People';

export const data = [
    {
        icon: <InventoryIcon />,
        name: 'Productos',
        submenu: [
            { title: 'Productos', url: 'productos', icon: StorefrontIcon },
            { title: 'Odoo', url: 'productos-odoo', icon: StoreIcon },
            { title: 'Categorías', url: 'categorias-productos', icon: CategoryIcon },
            { title: 'Marcas', url: 'marcas-productos', icon: CorporateFareIcon },
            { title: 'Ordenamiento', url: 'orden-productos', icon: ViewModuleIcon },
            { title: 'Reseñas', url: 'comentarios-productos', icon: CommentIcon }
        ]
    },
    {
        icon: <ShoppingCartIcon />,
        name: 'E-commerce',
        submenu: [
            { title: 'Dashboard', url: 'dashboard', icon: DashboardIcon },
            { title: 'Clientes', url: 'clientes', icon: PeopleIcon },
            { title: 'Pedidos', url: 'pedidos', icon: ReceiptIcon },
            { title: 'Pedidos incompletos', url: 'pedidos-incompletos', icon: ReceiptLongIcon },
            { title: 'Carrito abandonado', url: 'carrito-abandonado', icon: ProductionQuantityLimitsIcon },
            { title: 'Costo de ventas ONL', url: 'costo-ventas', icon: PointOfSaleIcon },
            { title: 'Métodos de envío', url: 'metodos-envio', icon: LocalShippingIcon },
            { title: 'Cupones', url: 'cupones', icon: LocalOfferIcon },
            { title: 'Promociones', url: 'promociones', icon: DiscountIcon },
            { title: 'Contacto', url: 'contacto', icon: MarkEmailUnreadIcon }
        ]
    },
    {
        icon: <FolderIcon />,
        name: 'Médicos',
        submenu: [
            { title: 'Listado', url: 'directorio-medico', icon: LocalHospitalIcon },
            { title: 'Alta', url: 'nuevo-medico', icon: LibraryAddIcon },
            { title: 'Pedidos', url: 'pedidos-medicos', icon: ReceiptLongIcon },
            { title: 'Cupones', url: 'cupones-medicos', icon: LocalOfferIcon },
            { title: 'Resumen', url: 'resumen-medicos', icon: AssessmentIcon }
        ]
    },
    {
        icon: <SettingsIcon />,
        name: 'Configuración',
        submenu: [
            { title: 'Admins', url: 'admins', icon: AdminPanelSettingsIcon },
            { title: 'Banners Tienda', url: 'banners-tienda', icon: ViewCarouselIcon },
            { title: 'Extras', url: 'tools', icon: BuildIcon },
            { title: 'Reporte Webinar', url: 'reporte-webinar', icon: ArticleIcon },
            { title: 'Pedidos incompletos', url: 'incompletos', icon: FileDownloadIcon },
        ]
    },
    {
        icon: <BookIcon />,
        name: 'Blog',
        submenu: [
            { title: 'Entradas', url: 'blog', icon: ViewComfyIcon },
            { title: 'Nueva entrada', url: 'nuevo-blog', icon: LibraryAddIcon }
        ]
    },
    {
        icon: <StoreIcon />,
        name: 'Sucursales',
        submenu: [
            { title: 'Sucursales', url: 'sucursales', icon: StorefrontIcon },
            { title: 'Nueva sucursal', url: 'nueva-sucursal', icon: AddBusinessIcon }
        ]
    }
];
